import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "../../../components/vendorManager/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import Pagination from "../../../components/ui/Pagination";
import SelectField from "../../../components/ui/form/SelectField";
import InputField from "../../../components/ui/form/InputField";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/vendorManager/apiRequest";
import { useSelector } from "react-redux";
import { getFileUrl } from "../../../utils/helper";

const ExcelImportProducts = () => {

  const { id } = useParams('id');

  const [selectedExcelImportId, setSelectedExcelImportId] = useState("");

  const [search, setSearch] = useState("");
  const debounceRef = useRef(null);

  const {
    currentPage,
    data: products,
    error,
    setFilters: setImportFilters,
    fetchData,
    limit,
    loading,
    setPage,
    setSorting,
    sort,
    totalItems,
    totalPages,
  } = usePaginate({
    apiMethod: apiRequest.getProducts,
    dataKey: "products",
    data: { id }
  });

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const f = {};
      if (id) f.excelImportId = id
      if (search) f.excelName = { $regex: search.trim(), $options: "i" };
      setImportFilters(f);
    }, 350);
    return () => clearTimeout(debounceRef.current);
  }, [search]);



  const handleSort = (field) => {
    const order =
      sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
    setSorting({ sortField: field, sortOrder: order });
  };


  return (
    <Layout>
      <Helmet>
        <title>Imported Products</title>
      </Helmet>

      <div className="p-4 bg-white rounded">
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_120px] gap-2 mb-3">
          <InputField placeholder="Search by excel name..." value={search} onChange={(e) => setSearch(e.target.value)} />
          <button className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800" onClick={() => { setSearch(""); }}>
            Clear
          </button>
        </div>


        <Table
          headers={[
            { label: "Product Name", key: "name", sorting: true },
            { label: "Image", key: "image", sorting: true },
            { label: "Serial No", key: "itemNo", sorting: true },
            { label: "Main Category", key: "mainCategory", sorting: true },
            { label: "Category", key: "itemCategory", sorting: true },
            { label: "Veg / Non Veg", key: "veg/nonveg", sorting: true },
            { label: "Vendor Price", key: "vendorPrice", sorting: true },
            { label: "Customer Price", key: "finalPrice", sorting: true },
            { label: "GST (%)", key: "gstAmount", sorting: true },
            { label: "Description", key: "Description", sorting: true },
            { label: "Quantity", key: "quantity", sorting: true },
            { label: "Status", key: "status", sorting: true },
            { label: "Created At", key: "createdAt", sorting: true },
            { label: "Action", key: "action", sorting: false },
          ]}
          loading={loading}
          handleSort={handleSort}
          sort={sort}
          error={error}
          cols={12}
          renderRow={
            <tbody className="bg-white divide-y divide-gray-200">
              {products?.map((product) => (
                <tr
                  key={product._id}
                  className="transition-colors hover:bg-gray-50"
                >
                  <td className="px-3 py-3">
                    <span className="font-semibold text-gray-800">
                      {product.name || "-"}
                    </span>
                  </td>
                  <td className="px-3 py-3">
                    <div className="w-16 h-16 overflow-hidden">
                      <img
                        src={getFileUrl(product?.image)}
                        alt={product?.name}
                        className="object-contain w-full h-full border border-gray-300 rounded"
                      />
                    </div>
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product.itemNo || "-"}
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product?.mainCategory?.name || "-"}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product.itemCategory || "-"}
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product?.food_type || "-"}
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-700">
                    ₹{product.vendorPrice?.toFixed(2) || "0.00"}
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-700">
                    ₹{product.finalPrice?.toFixed(2) || "0.00"}
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product.gstAmount ? `${product.gstAmount}%` : "0%"}
                  </td>
                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product.description ? `${product.description}` : ""}
                  </td>

                  <td className="px-3 py-3 text-sm text-gray-600">
                    {product.quantity || 0}
                  </td>



                  {/* Status */}
                  <td className="px-3 py-3 text-sm">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${product.status === "Active"
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                        }`}
                    >
                      {product.status || "Inactive"}
                    </span>
                  </td>

                  {/* Created At */}
                  <td className="px-3 py-3 text-xs text-gray-500">
                    {new Date(product.createdAt).toLocaleDateString("en-IN", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>

                  {/* Action Buttons */}
                  <td></td>
                </tr>
              ))}
            </tbody>
          }
        />
        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems: totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}
      </div>
    </Layout>
  );
};

export default ExcelImportProducts;
